/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Announcement } from 'CalltakingCoreApi';
import { receivedAnnouncement } from '../+state/announcement.actions';
import { ClusterUrlProviderService } from '../../core/services/cluster-url-provider.service';
import { StompBaseConsumer } from '../../core/abstract/stomp-base-consumer';
import { StompManagerService } from 'src/app/core/services/stomp-manager/stomp-manager.service';
import { Topic } from '../../user/model/multiple-subscriptions';


@Injectable({
    providedIn: 'root'
})
export class AnnouncementService extends StompBaseConsumer implements OnDestroy {
    private readonly API_BASE_URL = '/api/imc/v1/';
    private readonly SEND_ANNOUNCEMENT_URL = `${this.API_BASE_URL}announcement`;

    constructor(
        private http: HttpClient,
        private clusterUrlProviderService: ClusterUrlProviderService,
        protected store: Store,
        protected stompManager: StompManagerService
    ) {
        super(stompManager, store);
    }

    protected handleNewAnnouncementMessage(announcement: Announcement) {
        this.store.dispatch(receivedAnnouncement({ announcement }));
    }

    protected getTopics(): Topic[] {
        return [Topic.ANNOUNCEMENT_MESSAGE_NEW];
    }

    protected getTopicHandlers(): { [p in Topic]?: (message: any) => void } {
        return {
            [Topic.ANNOUNCEMENT_MESSAGE_NEW]: this.handleNewAnnouncementMessage.bind(this),
        };
    }

    handleSubscriptionInit(topic: string, receiptId: string, clusterName?: string, clusterLabel?: string): void {
        console.info(`${clusterLabel ? clusterLabel : ''} Announcement topic ${topic} subscription success: ${receiptId}`);
    }

    handleSubscriptionEnd(topic: string, receiptId: string, clusterName?: string, clusterLabel?: string): void {
        console.info(`${clusterLabel ? clusterLabel : ''} Call topic ${topic} subscription end: ${receiptId}`);
    }

    handleStompError(topic: string, receiptId: string, error: string, clusterName?: string, clusterLabel?: string): void {
        console.info(`${clusterLabel ? clusterLabel : ''} Announcement topic ${topic} subscription failed=${error} for receiptId=${receiptId}`);
    }

    public sendAnnouncement(announcement: Announcement, clusterName: string) {
        const url = this.clusterUrlProviderService.getClusterSpecificUrl(clusterName, this.SEND_ANNOUNCEMENT_URL);
        return this.http.post(url, announcement);
    }
}
